module.exports = __webpack_public_path__ + "img/rank-bronze.f7195ab1.png";